import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { InboxNotiType } from '@diritto/common/notification/constants';
import {
  InboxNotiResponseDto,
  InboxNotiUnreadCountResponseDto,
  InboxProfileNotiUnreadCountResponseDto,
} from '@diritto/common/notification/dtos/inbox-noti.response.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class NotiApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getInboxNotifications(params: BasePaginatorDto, options?: AxiosRequestConfig) {
    const res = await this.http.get<InboxNotiResponseDto>(`${this.url}/relay/notifications/inbox`, {
      params,
      ...options,
    });
    return res.data;
  }

  async findInboxNotificationsByInboxNotiType(
    inboxNotiType: InboxNotiType,
    params: BasePaginatorDto,
    options?: AxiosRequestConfig,
  ) {
    const res = await this.http.get<InboxNotiResponseDto>(`${this.url}/relay/notifications/inbox/${inboxNotiType}`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getInboxNotiUnreadCount(options?: AxiosRequestConfig) {
    const res = await this.http.get<InboxNotiUnreadCountResponseDto>(
      `${this.url}/notifications/inbox/unread-count`,
      options,
    );
    return res.data;
  }

  async readAllInboxNotifications() {
    const res = await this.http.put<undefined, ResponseDto>(`${this.url}/notifications/inbox/read-all`, undefined);
    return res.data;
  }

  async getInboxProfileNotiUnreadCount() {
    const res = await this.http.get<InboxProfileNotiUnreadCountResponseDto>(
      `${this.url}/notifications/inbox/profiles/unread-count`,
    );
    return res.data;
  }
}
